/* global google */
import _ from 'lodash';
import $ from 'jquery';
import { forceClickElement } from 'javascripts/util/force_click_element';
import { handleChartError } from 'javascripts/bookmarks/handle_chart_error';
import { bookmarkDisplayErrorMessage } from 'javascripts/bookmarks/common';

class CustomPivotChart {
  constructor(divId, options) {
    this.divId = divId;
    this.options = options;

    if (!this.options.renderOptions) {
      this.options.renderOptions = {};
    }
    this.container = $(`#${this.divId}`);

    $(this.initializeListeners.bind(this));
    $(document).one('page:load', this.initializeListeners.bind(this));

    $(document).one('page:before-unload', () => {
      $(window).off('resize.customPivotChart');
      $('.format-google-chart').off('click.customPivotChart');
    });

    if (this.canAccessGoogleVisualization()) {
      this.createChart();
    } else {
      $.getScript('https://www.google.com/jsapi', (data, textStatus) =>
        google.load('visualization', '1', {
          packages: ['corechart', 'charteditor'],
          language: 'en-US',
          callback: () => this.createChart(),
        })
      );
    }
  }

  initializeListeners() {
    $(window).on('resize.customPivotChart', () => this.drawChart());
    $('.format-google-chart').on('click.customPivotChart', () =>
      this.showChartEditor()
    );
  }

  canAccessGoogleVisualization() {
    if (
      typeof google === 'undefined' ||
      typeof google.visualization === 'undefined' ||
      typeof google.visualization.ChartEditor === 'undefined'
    ) {
      return false;
    } else {
      return true;
    }
  }

  showChartEditor() {
    if (document.querySelector('.google-visualization-charteditor-dialog')) {
      return;
    }

    this.chartEditor = new google.visualization.ChartEditor();
    google.visualization.events.addListener(this.chartEditor, 'ok', () =>
      this.chartEditorCallback()
    );

    this.chartEditor.openDialog(this.chartWrapper, {});

    // We only want the 3rd tab, so we force click it (array index 2) and then remove the tab bar.
    // The tabs used to always be .charts-tab, but now they are intermittently .charts-tab or .goog-tab,
    // so we need to check both.
    const tab = $('.charts-tab').eq(2)[0] || $('.goog-tab').eq(2)[0];
    forceClickElement(tab);
    setTimeout(() => {
      $('.charts-tab').remove();
      $('.goog-tab').remove();
      $('.modal-dialog-title-text').html('Customize style');
    }, 10);
  }

  chartEditorCallback() {
    if (this.chartEditor) {
      this.chartWrapper = this.chartEditor.getChartWrapper();
      this.chartEditor = null;
    }

    setTimeout(() => $('.format-google-chart').blur(), 10);
    this.saveChartOptions();
    this.drawChart();
  }

  saveChartOptions() {
    this.options.renderOptions = {};
    this.options.renderOptions.chartType = this.chartWrapper.getChartType();
    this.options.renderOptions.options = this.chartWrapper.getOptions();

    const url = this.container.attr('data-bookmark-url');
    $.ajax({
      type: 'PUT',
      dataType: 'json',
      url,
      contentType: 'application/json; charset=UTF-8',
      processData: false,
      data: JSON.stringify({
        bookmarks_custom_pivot: {
          configuration_render_options: this.options.renderOptions,
        },
        reactive_client_id: window.reactiveClientId(),
      }),
    });
  }

  drawChart() {
    if (this.chartWrapper) {
      let width = this.container.width();

      const bottomMargin = this.options.chartType === 'list' ? 1 : 50;

      let height = Math.min(
        $(window).height() - this.container.offset().top - bottomMargin,
        1000
      );

      if (this.options.publishing) {
        height = Math.min(width / 1.8, 500);
      }

      this.chartWrapper.setOption('height', this.options.forceHeight || height);

      // Max width for image based chart is 1000px
      // https://web.archive.org/web/20171018040316/https://developers.google.com/chart/image/docs/chart_params#chart-size-chs-all-charts
      // Note that google charts automagically cuts the area of the image to be a max to 300 000 pixel^2
      if (
        this.options.renderOptions.chartType === 'ImageChart' &&
        width > 1000
      ) {
        width = 1000;
      }

      this.chartWrapper.setOption('width', this.options.forceWidth || width);

      this.chartWrapper.setOption('fontName', 'Helvetica, Arial, sans-serif');

      if ($('body').hasClass('report')) {
        // If user is exporting the report, display as many lines of legend as possible.
        // Picked an arbitrarily large number (10,000) that seems like it sohuld be enough for most users.
        // NOTE: only works when position is set to "top", has no effect otherwise.
        // https://developers.google.com/chart/interactive/docs/gallery/linechart
        let legendOptions = this.chartWrapper.getOption('legend') || {};
        if (_.isString(legendOptions)) {
          legendOptions = { position: legendOptions };
        }

        if (_.isBoolean(legendOptions)) {
          legendOptions = {};
        }

        legendOptions.maxLines = 10000;
        this.chartWrapper.setOption('legend', legendOptions);
      }

      this.chartWrapper.draw();
    }
  }

  getDataTable() {
    let colDepth, rowDepth;
    if (this.dataTable) {
      return this.dataTable;
    }

    const tableHeaders = [''];
    this.dataTable = { 0: tableHeaders };
    const rowHeaders = {};

    const data = this.maybeCastDates(this.options.data);
    if (data[0][0].empty) {
      colDepth = data[0][0].colspan;
    }
    if (data[0][0].empty) {
      rowDepth = data[0][0].rowspan;
    }

    for (let index = 0; index < data.length; index++) {
      const dataRow = data[index];
      let currentColSpan = 0;
      for (let innerIndex = 0; innerIndex < dataRow.length; innerIndex++) {
        var position;
        const column = dataRow[innerIndex];
        if (column.simple_label && typeof column.simple_label === 'string') {
          column.simple_label = _.unescape(column.simple_label);
        }

        if (!column.header) {
          // cast floats into number for the chart
          if (
            column.simple_label &&
            column.simple_label.indexOf &&
            column.simple_label.indexOf('.') >= 0
          ) {
            const length_after_decimal =
              column.simple_label.split('.')[1].length;
            if (
              parseFloat(column.simple_label).toFixed(length_after_decimal) ===
              column.simple_label
            ) {
              column.simple_label = parseFloat(column.simple_label);
            }
          }

          // Cast ints into numbers for the chart
          if (
            column.simple_label &&
            column.simple_label.match &&
            column.simple_label.match(/^\d+$/)
          ) {
            if (
              parseInt(column.simple_label).toString() === column.simple_label
            ) {
              column.simple_label = parseInt(column.simple_label);
            }
          }
        }

        if (dataRow[0].empty) {
          if (!column.empty) {
            for (let num = 0; num < column.colspan; num++) {
              position = innerIndex - 1 + num + currentColSpan;
              rowHeaders[position] = rowHeaders[position]
                ? rowHeaders[position] + ' - ' + column.simple_label
                : column.simple_label;
            }
            currentColSpan += column.colspan - 1;
          }
        } else {
          if (column.header) {
            position = index + 1 - (rowDepth || 0);
            tableHeaders[position] = tableHeaders[position]
              ? tableHeaders[position] + ' - ' + column.simple_label
              : column.simple_label;
          } else {
            if (typeof column.simple_label === 'number') {
              column.simple_label = Math.round(column.simple_label * 100) / 100; // Round off numbers to nearset 2 decimal places
            }

            if (!this.dataTable[innerIndex]) {
              this.dataTable[innerIndex] = [rowHeaders[innerIndex - colDepth]];
            }
            this.dataTable[innerIndex].push(column.simple_label);
          }
        }
      }
    }
    return this.dataTable;
  }

  cleanRenderOptions(renderOptions) {
    if (renderOptions.title == null || renderOptions.title === '') {
      renderOptions.title = this.options.chartTitle;
    }

    // sortColumn is not cast by google charts, so the string value will blow up
    // the visualization and render an error to the user
    if (renderOptions.sortColumn) {
      renderOptions.sortColumn = parseInt(renderOptions.sortColumn);
    }

    return renderOptions;
  }

  // By default, google charts will not cast strings that look like dates as
  // dates. So, we use metadata passed in with our table data to identify date
  // columns that are strings and cast them as dates. if there are no date
  // columns, we skip this
  maybeCastDates(data) {
    // Skip casting dates if there ara no selected columns for the chart
    if (!data[0]) {
      return data;
    }

    // get the fields indexes that are marked as dates or return if there aren't any
    const dateColumns = data[0]
      .map(function (x, i) {
        if (x.type === 'date') {
          return i;
        } else {
          return null;
        }
      })
      .filter(x => x !== null);

    // in each row, cast the columns (identified above) as dates
    if (data[0].some(x => x.type === 'date')) {
      for (let rowNum = 0; rowNum < data.length; rowNum++) {
        // the first row is the header information
        if (rowNum === 0) {
          continue;
        }
        for (let colNum of dateColumns) {
          // Only parse date if there's an actual value.
          if (data[rowNum][colNum]) {
            data[rowNum][colNum] = new Date(data[rowNum][colNum]);
          }
        }
      }
    }
    return data;
  }

  fixDateAxis(data, options) {
    // If we are using dates for the horiziontal axis we need to remove the default min and max values of ""
    // as google charts expects them to be date objects not strings
    if (data[0][0].type === 'date' && options.hAxis) {
      delete options.hAxis.minValue;
      delete options.hAxis.maxValue;
    }
    return options;
  }

  createChart() {
    // Hide legend if it contains no data; otherwise set text size.
    let dataTable, defaultChartType, legend;
    if (
      _.every(
        this.options.data,
        row => _.first(row).empty || _.first(row).simple_label === ''
      )
    ) {
      legend = { position: 'none' };
    } else {
      legend = { textStyle: { fontSize: 12 } };
    }

    let renderOptions = _.defaults(this.options.renderOptions.options || {}, {
      chartArea: {
        width: '70%',
      },
      legend,
    });

    renderOptions = this.cleanRenderOptions(renderOptions);

    renderOptions = _.defaults(
      this.options.globalOverrides || {},
      renderOptions
    );

    if (this.options.chartType === 'list') {
      defaultChartType = 'Table';
      dataTable = google.visualization.arrayToDataTable(
        this.maybeCastDates(this.options.data),
        false
      );
      if (this.options.renderOptions.chartType === 'ScatterChart') {
        this.tidyScatterChartData(dataTable);
      }
    } else {
      defaultChartType = 'ColumnChart';
      dataTable = _.toArray(this.getDataTable());
    }

    renderOptions = this.fixDateAxis(this.options.data, renderOptions);

    try {
      this.chartWrapper = new google.visualization.ChartWrapper({
        chartType: this.options.renderOptions.chartType || defaultChartType,
        dataTable,
        options: renderOptions,
        containerId: this.divId,
      });

      google.visualization.events.addListener(
        this.chartWrapper,
        'error',
        error => this.chartError(error)
      );
      this.drawChart();
    } catch (e) {
      if (
        e.message.includes('google-visualization-errors: container is null')
      ) {
        // do nothing
      } else {
        bookmarkDisplayErrorMessage();
        throw e;
      }
    }
  }

  tidyScatterChartData(dataTable) {
    if (this.options.data[0]) {
      if (this.options.data[0][2]) {
        dataTable.setColumnProperty(2, 'role', 'annotation');
      }
      if (this.options.data[0].length > 3) {
        return dataTable.removeColumns(3, this.options.data[0].length - 1);
      }
    }
  }

  chartError(error) {
    console.error(error);
    handleChartError(error.message, this.options.renderOptions.chartType);
  }
}

export default CustomPivotChart;
